import { Amplify } from 'aws-amplify'

export const hasUserPoolConfigured = (): boolean => {
  const cfg = Amplify.getConfig()
  return !!cfg?.Auth?.Cognito?.userPoolId && !!cfg?.Auth?.Cognito?.userPoolClientId
}
